import { COLORS } from '@apari-shared/constants';
import { ComponentsOverrides, Theme } from '@mui/material';

const styleOverrides: ComponentsOverrides<Theme>['MuiSelect'] = {
  root: {
    fontSize: 13,
    color: COLORS.apariBlack80,
  },
};

export default styleOverrides;
